import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import PropTypes from "prop-types";
import { Link, useParams } from "react-router-dom";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import Check from "@material-ui/icons/Check";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import { bookingApi, masterApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export function ViewSector(props) {
  const classes = useStyles();

  const viewSectorSignal = React.useRef(new AbortController());

  const { id } = useParams();

  const [data, setData] = useState(null);
  const [sectorBooking, setSectorBooking] = useState(null);

  useEffect(() => {
    return () => viewSectorSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      masterApi
        .get(`Sectors/${id}`, {
          signal: viewSectorSignal.current.signal
        })
        .then(resp => {
          setData(resp);
        });
    }
  }, [id]);

  useEffect(() => {
    if (
      data !== null &&
      data.publicationStatus !== 0 &&
      (token["booking.sectors.read"] === "allowed" || token.is_admin === "True")
    ) {
      bookingApi
        .get("/Sectors/" + id, {
          signal: viewSectorSignal.current.signal
        })
        .then(resp => setSectorBooking(resp))
        .catch(error => console.log(error));
    }
  }, [data]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>VIEW SECTOR</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <GridContainer>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Code"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.code : "",
                    disabled: true
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: data ? data.name : "",
                    disabled: true
                  }}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        {data !== null &&
          data.publicationStatus !== 0 &&
          sectorBooking !== null && (
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>BOOKING CONFIGURATION</h4>
              </CardHeader>
              <CardBody>
                {(token["booking.sectors.write"] === "allowed" ||
                  token.is_admin === "True") &&
                  data.publicationStatus === 1 && (
                    <Link to={"/admin/Sector/EditBookingConfiguration/" + id}>
                      <Button color="rose" type="button" value="Edit">
                        Edit
                      </Button>
                    </Link>
                  )}
                <GridContainer>
                  <GridItem xs={12} sm={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sectorBooking.isInternationalTravel}
                          disabled={true}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="Is International Travel"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sectorBooking.hasGST}
                          disabled={true}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="Has GST"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <CustomInput
                      labelText="TFS Look Up Code"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true,
                        value: sectorBooking.tfsLookUpCode ?? ""
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomInput
                      labelText="Next Sector"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true,
                        value:
                          sectorBooking.nextSector === null
                            ? ""
                            : sectorBooking.nextSector.code +
                              " - " +
                              sectorBooking.nextSector.name
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          )}
      </GridItem>
    </GridContainer>
  );
}

ViewSector.propTypes = {
  history: PropTypes.object
};
